import React from 'react'
import Section from './Section/Section'
import Card from './Card/Card'
import FeaturedContentLink from './Link/FeaturedContentLink'
import { addQueryParamsToUrl } from '../../util/imageUrlUtil'
import withErrorBoundary from '../../util/components/ErrorBoundary/withErrorBoundary'

type FeaturedContentAdapterProps = {
  fields: {
    title: string
    description: string
    href: string
    image: { src: string; alt: string } | null
    intro: string
    linkNewTab: boolean
    linkText: string
    linkTitle: string
  }
}

// Size the thumbnail image

function FeaturedContentAdapter({
  fields: {
    title,
    description,
    image,
    href,
    linkTitle,
    linkNewTab,
    linkText,
    intro,
  },
}: FeaturedContentAdapterProps) {
  const featuredLinkProps = {
    href: href,
    text: linkText,
    title: linkTitle,
    newWindow: linkNewTab,
  }

  const titleLinkProps = {
    href: href,
    newWindow: linkNewTab,
  }

  const imageProps = image
    ? {
        src: addQueryParamsToUrl(image.src, `mh=250`) || '',
        alt: image.alt,
      }
    : null

  return (
    <Section intro={intro}>
      <Card
        title={title}
        titleAttr={titleLinkProps}
        description={<div dangerouslySetInnerHTML={{ __html: description }} />}
        image={imageProps}
        featuredLink={<FeaturedContentLink linkAttr={featuredLinkProps} />}
      />
    </Section>
  )
}

export default withErrorBoundary(FeaturedContentAdapter, {
  component: 'Featured-Content',
})
